export function calculateProbabilityPercent(value?: number): number | undefined {
  if (value === null || value === undefined) {
    return undefined;
  }
  return Math.floor(value * 100);
}
